import React from 'react';
import cx from 'classnames';
import styles from './Select.module.scss';

const Select = ({ error, ...rest }) => (
  <select className={cx(styles.root, { [styles.root_error]: error })} {...rest} />
);

export default Select;
